


































































































































import { computed, defineComponent, reactive, ref } from "@vue/composition-api";
import Layout from "@/components/Atoms/Layout/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import Pagination from "@/components/Atoms/Pagination/index.vue";
import PageHeader from "@/components/Molecules/PageHeader/index.vue";
import ListFilter from "@/components/Molecules/ListFilter/index.vue";
import FilterSection from "@/components/Molecules/FilterSection/index.vue";
import OccSearchMultiSelectbox from "@/components/Atoms/OccSearchMultiSelectbox/index.vue";
import OccSearchSelectbox from "@/components/Atoms/OccSearchSelectbox/index.vue";
import Checkbox from "@/components/Atoms/Forms/Checkbox/index.vue";
import SearchTextField from "@/components/Atoms/Forms/SearchTextField/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import { Props } from "@/components/Molecules/ListTable/index.vue";
import TableFooter from "@/components/Molecules/TableFooter/index.vue";
import SponsoredEventEntryApplicantsTable from "../SponsoredEventEntryApplicants/Organisms/SponsoredEventEntryApplicantsTable.vue";
import CsvCustomizeModal from "@/components/Organisms/CsvCustomizeModal/index.vue";
import ConfirmModal from "@/components/Organisms/modals/ConfirmModal/index.vue";
import DateRangeSelector from "@/components/Molecules/DateRangeSelector/index.vue";
import HelpLink from "@/components/Atoms/HelpLink/index.vue";

// TODO: お気に入り更新API をワンキャリア主催イベントのAPIに置き換え
import {
  getSponsoredEventEntryApplicants,
  getSponsoredEventEntryApplicantSearchOptions,
  startGenerateSponsoredEventEntryApplicantsCsv,
  getPartnerEntryCsvColumns,
  upsertPartnerEntryCsvColumns
} from "@/api";
import {
  PRIVILEGE_ENTRIES_DOWNLOAD,
  hasPrivilege
} from "@/helpers/privilege-helper";
import { useRequest } from "@/helpers/hooks/useRequest";
import {
  selectListGenerator,
  correctIdArrayParams,
  ListFilterConditions
} from "@/helpers/sponsoredEventEntryApplicants";
import { ApiRequest, ApiResponse, Order } from "@/api/types";
import { CsvColumns } from "@/components/Organisms/CsvCustomizeModal/types";
import { AvailableCsvColumns } from "@/helpers/sponsoredEventEntryApplicants";

type SponsoredEventEntryApplicantFilterData = {
  keyword: string;
  event_ids: number[];
  universities: string[];
  graduateYears: string[];
  grades: string[];
  schedules: number[];
  entryDate: {
    from: string;
    to: string;
  };
};

type SponsoredEventEntryApplicantFilterName =
  | "event_ids"
  | "universities"
  | "graduateYears"
  | "grades"
  | "schedules"
  | "entryDate";

type SponsoredEventEntryApplicantFilterType =
  | "checkbox"
  | "multiSelectbox"
  | "dateRange";

interface SponsoredEventEntryApplicantFilterCondition {
  label: string;
  checkbox_label?: string;
  name: SponsoredEventEntryApplicantFilterName;
  type: SponsoredEventEntryApplicantFilterType;
}

export default defineComponent({
  name: "SponsoredEventEntryApplicants",
  components: {
    Layout,
    OccHeading,
    OccButton,
    Pagination,
    PageHeader,
    ListFilter,
    FilterSection,
    OccSearchMultiSelectbox,
    OccSearchSelectbox,
    Checkbox,
    SearchTextField,
    LoadingView,
    TableFooter,
    SponsoredEventEntryApplicantsTable,
    CsvCustomizeModal,
    ConfirmModal,
    DateRangeSelector,
    HelpLink
  },
  setup(_props, { root }) {
    /** ========================================
     * フィルタ
     * ========================================*/
    const filterState = reactive<SponsoredEventEntryApplicantFilterData>({
      keyword: "",
      event_ids: [],
      universities: [],
      graduateYears: [],
      grades: [],
      schedules: [],
      entryDate: { from: "", to: "" }
    });

    filterState.event_ids = [];
    if (root.$route.query.eventId)
      filterState.event_ids = [Number(root.$route.query.eventId)];

    const queryParams = root.$route.query;

    const [
      { data: searchOptions, loading: searchOptionsLoading },
      runGetSponsoredEventEntryApplicantSearchOptions
    ] = useRequest(() => getSponsoredEventEntryApplicantSearchOptions(), {
      immediate: true
    });

    const [
      { data: sponsoredEventEntryApplicants, loading: usersLoading },
      runGetSponsoredEventEntryApplicants
    ] = useRequest(
      () =>
        getSponsoredEventEntryApplicants({
          ...searchParams.value,
          limit: displayCount.value,
          offset: displayCount.value * (currentPage.value - 1)
        }),
      { immediate: false }
    );

    const load = async () => {
      await runGetSponsoredEventEntryApplicantSearchOptions();
      await runGetSponsoredEventEntryApplicants();
      await restoreFilterStateFromQueryParams();
    };
    load();

    const headers = reactive<Props["headers"]>([
      {
        name: "ユーザー名",
        subHeaders: [{ name: "識別コード" }, { name: "カナ" }],
        sizeInner: "100px",
        minSizeContainer: "200px"
      },
      {
        name: "大学名",
        subHeaders: [{ name: "卒年" }, { name: "学年・学部" }],
        sizeInner: "220px",
        minSizeContainer: "220px"
      },
      {
        name: "申込イベント",
        minSizeContainer: "250px"
      },
      {
        name: "申込スケジュール",
        subHeaders: [{ name: "スケジュール開催日" }],
        minSizeContainer: "250px"
      },
      {
        name: "申込日時",
        sortParam: "checkin_date",
        order: "desc",
        sizeInner: "130px",
        minSizeContainer: "170px"
      }
    ]);

    const hasCsvDownloadPriviledge = hasPrivilege(PRIVILEGE_ENTRIES_DOWNLOAD);

    // クエリパラメータから検索オプションを復元する
    const restoreFilterStateFromQueryParams = async () => {
      if (queryParams["schedules[]"]) {
        filterState.schedules = correctIdArrayParams(
          queryParams["schedules[]"],
          searchOptions.value?.schedules.map((obj: any) => obj.id)
        );
      }
      if (queryParams["event_ids[]"]) {
        filterState.event_ids = correctIdArrayParams(
          queryParams["event_ids[]"],
          searchOptions.value?.events.map((obj: any) => obj.id)
        );
      }
      setCurrentFilterCount();
    };

    const filterCount = ref(0);

    const scheduleSelectItemList = computed(() => {
      if (!searchOptions.value) return [];
      const schedules = searchOptions.value?.schedules;
      if (!schedules) return [];

      const tmpSchedulesItemList = schedules.map(
        (v: ApiResponse.SponsoredEventEntryApplicantScheduleSelectItem) => {
          return {
            value: v.id,
            label: v.title
          };
        }
      );
      return tmpSchedulesItemList;
    });

    const eventSelectItemList = computed(() => {
      if (!searchOptions.value) return [];
      const events = searchOptions.value?.events;
      if (!events) return [];

      const tmpEventsItemList = events.map(
        (v: ApiResponse.SponsoredEventEntryApplicantEventSelectItem) => {
          return {
            value: v.id,
            label: v.title
          };
        }
      );

      return tmpEventsItemList;
    });

    const selectItemList = computed(() => {
      return {
        universities: selectListGenerator(
          searchOptions.value?.universities || []
        ),
        graduateYears: selectListGenerator(
          searchOptions.value?.graduate_years || []
        ),
        grades: selectListGenerator(searchOptions.value?.grades || []),
        event_ids: eventSelectItemList.value,
        schedules: scheduleSelectItemList.value
      };
    });

    const onChangeMultiSelect = (
      key: SponsoredEventEntryApplicantFilterName,
      newVal: string[]
    ) => {
      filterState[key] = newVal as any;
    };

    const onSearchText = async () => {
      moveFiresPage();
      await runGetSponsoredEventEntryApplicants();
    };

    const onSubmitFilter = async () => {
      moveFiresPage();
      await runGetSponsoredEventEntryApplicants();
      setCurrentFilterCount();
    };

    const onResetFilter = async () => {
      filterState.keyword = "";

      ListFilterConditions.forEach(condition => {
        const key: string = condition.name;
        switch (key) {
          case "universities":
          case "graduateYears":
          case "grades":
          case "event_ids":
          case "schedules":
            filterState[key] = [];
            return;
          case "entryDate":
            filterState[key] = { from: "", to: "" };
            return;
        }
      });
      moveFiresPage();
      await runGetSponsoredEventEntryApplicants();
      setCurrentFilterCount();
    };

    const setCurrentFilterCount = () => {
      const currentFilterCount = ListFilterConditions.reduce(
        (preFilterCount: number, condition) => {
          const key: string = condition.name;
          switch (key) {
            case "universities":
            case "graduateYears":
            case "grades":
            case "schedules":
            case "event_ids":
              if (filterState[key].length) {
                return preFilterCount + 1;
              } else {
                return preFilterCount;
              }
            case "entryDate":
              if (filterState[key].from || filterState[key].to) {
                return preFilterCount + 1;
              } else {
                return preFilterCount;
              }
            default:
              return preFilterCount;
          }
        },
        0
      );
      filterCount.value = currentFilterCount;
    };

    /** ========================================
     * ページネーション
     * ========================================*/
    const currentPage = ref(1);

    const displayCount = ref(25);

    const displayCountSelectList = [
      { value: 25, label: "25件" },
      { value: 50, label: "50件" },
      { value: 100, label: "100件" },
      { value: 250, label: "250件" },
      { value: 500, label: "500件" }
    ];

    const totalPageCount = computed(() => {
      if (
        !sponsoredEventEntryApplicants.value ||
        !sponsoredEventEntryApplicants.value.total
      ) {
        return 1;
      }
      return Math.ceil(
        sponsoredEventEntryApplicants.value?.total / displayCount.value
      );
    });

    const moveFiresPage = () => {
      currentPage.value = 1;
    };

    const onChangePage = async (pageNumber: number) => {
      currentPage.value = pageNumber;
      await runGetSponsoredEventEntryApplicants();
    };

    const onChangeDisplayCount = async (count: number) => {
      displayCount.value = count;
      moveFiresPage();
      await runGetSponsoredEventEntryApplicants();
    };

    /** ========================================
     * ソート
     * ========================================*/
    const sortState = reactive<
      Pick<ApiRequest.SponsoredEventEntryApplicants, "order">
    >({
      order: "desc"
    });

    const onChangeOrder = async (order: Order, headerIndex: number) => {
      const targetHeader = headers[headerIndex];
      const sort = targetHeader.sortParam;

      if (!sort) {
        return;
      }

      sortState.order = order;
      targetHeader.order = order;
      moveFiresPage();

      await runGetSponsoredEventEntryApplicants();
    };

    /** ========================================
     * 行選択
     * ========================================*/
    const selectedRowList = ref<ApiResponse.SponsoredEventEntryApplicant[]>([]);

    const selectedRowCount = computed(() => selectedRowList.value.length);

    const onChangeRowValue = (
      list: ApiResponse.SponsoredEventEntryApplicant[]
    ) => {
      selectedRowList.value = list;
    };

    /** ========================================
     * アラート
     * ========================================*/
    const isLoading = computed<boolean>(() => {
      return !!usersLoading.value || !!searchOptionsLoading.value;
    });

    /** ========================================
     * CSV出力カラムの管理
     * ========================================*/
    const partnerEntryCsvColumns = ref<ApiResponse.PartnerEntryCsvColumn[]>();
    const excludedColumns = ref<CsvColumns[]>([]);
    const includedColumns = ref<CsvColumns[]>([]);

    const runGetPartnerEntryCsvColumns = async () => {
      const response = await getPartnerEntryCsvColumns();
      partnerEntryCsvColumns.value = response.data.csv_columns;
      updateDisplayCsvColumns();
    };

    const updateDisplayCsvColumns = () => {
      if (!partnerEntryCsvColumns.value) {
        return;
      }

      includedColumns.value = [];
      excludedColumns.value = [];

      partnerEntryCsvColumns.value.forEach(item => {
        const csvColumnObj = getCsvColumnObj(item.column);
        if (csvColumnObj) {
          includedColumns.value.push(csvColumnObj);
        }
      });

      excludedColumns.value = AvailableCsvColumns.filter(item => {
        return !includedColumns.value.find(includedCol => {
          return includedCol.name === item.name;
        });
      });
    };

    const getCsvColumnObj = (column: string) => {
      return AvailableCsvColumns.find(item => {
        return item.name === column;
      });
    };

    const csvColumnsSaveParams = computed(() => {
      const csvColumns = includedColumns.value.map((item, idx) => {
        return { column: item.name, position: idx };
      });
      if (
        partnerEntryCsvColumns.value?.find(
          item => item.column === "partner_entry_offer"
        )
      ) {
        const insertIndex = csvColumns.length;
        csvColumns.push({
          column: "partner_entry_offer",
          position: insertIndex
        });
      }
      // NOTE: entry_routeの出力カラムはライブ申込者一覧では出力可能カラムに含まれない。
      //       応募者一覧では設定可能なため、併用している時誤って削除されないよう、登録されていれば保存時にも追加する。
      //       なお、ライブ申込者一覧におけるCSV出力時にはこの設定は無視される。
      if (
        partnerEntryCsvColumns.value?.find(
          item => item.column === "entry_route"
        )
      ) {
        const insertIndex = csvColumns.length;
        csvColumns.push({
          column: "entry_route",
          position: insertIndex
        });
      }

      return {
        csv_columns: csvColumns
      };
    });

    const runUpsertPartnerEntryCsvColumns = async () => {
      const response = await upsertPartnerEntryCsvColumns(
        csvColumnsSaveParams.value
      );
      if (response.status !== 204) {
        showCsvDownloadError();
      }
    };

    /** =======================================
     * CSVダウンロード
     * =======================================*/
    const onClickCsvDownload = () => {
      showCsvCustomizeModal();
    };
    const csvCustomizeModalShow = ref<boolean>(false);

    const closeCsvCustomizeModal = () => {
      csvCustomizeModalShow.value = false;
    };

    const showCsvCustomizeModal = async () => {
      await runGetPartnerEntryCsvColumns();
      csvCustomizeModalShow.value = true;
    };

    const csvDownloadConfirmModalShow = ref(false);

    const closeCsvDownloadConfirmModal = () => {
      csvDownloadConfirmModalShow.value = false;
    };

    const updateCsvIncludedColumns = (
      newArray: {
        name: string;
        label: string;
      }[]
    ) => {
      includedColumns.value = newArray;
    };
    const updateCsvExcludedColumns = (
      newArray: {
        name: string;
        label: string;
      }[]
    ) => {
      excludedColumns.value = newArray;
    };

    const searchParams = computed<ApiRequest.SponsoredEventEntryApplicantsBase>(
      () => {
        const params: ApiRequest.SponsoredEventEntryApplicantsBase = {
          keyword: filterState.keyword,
          universities: filterState.universities,
          graduate_years: filterState.graduateYears,
          grades: filterState.grades,
          event_ids: filterState.event_ids,
          schedule_ids: filterState.schedules,
          order: sortState.order
        };
        // APIで以下の項目はオプショナルパラメータなので、空文字の場合はパラメータから除外する
        if (filterState.entryDate.from !== "") {
          params.entry_date_from = filterState.entryDate.from;
        }
        if (filterState.entryDate.to !== "") {
          params.entry_date_to = filterState.entryDate.to;
        }

        return params;
      }
    );

    const csvDownloadColumns = ref<string[]>();
    const csvDownloadParams = computed(() => {
      return {
        ...searchParams.value,
        output_columns: csvDownloadColumns.value || []
      };
    });

    const applyCsvDownload = async (items: string[]) => {
      await Promise.all([
        runUpsertPartnerEntryCsvColumns(),
        runCsvDownload(items)
      ]);
    };

    const runCsvDownload = async (items: string[]) => {
      csvDownloadColumns.value = items;
      const response = await startGenerateSponsoredEventEntryApplicantsCsv(
        csvDownloadParams.value
      );
      if (response.status === 200) {
        csvDownloadConfirmModalShow.value = true;
      } else {
        showCsvDownloadError();
      }
    };

    const showCsvDownloadError = () => {
      root.$store.commit("common/updateAlertView", {
        isVisible: true,
        title: "ダウンロードに失敗しました。リロードして再度お試しください。"
      });
    };

    const currentDateStr = computed<string>(() => {
      return new Date().toISOString().slice(0, 10);
    });

    const handleChangedEntryDateFrom = (value: string) => {
      filterState.entryDate.from = value;
    };

    const handleChangedEntryDateTo = (value: string) => {
      filterState.entryDate.to = value;
    };

    return {
      searchOptions,
      sponsoredEventEntryApplicants,
      usersLoading,
      searchOptionsLoading,
      headers,
      hasCsvDownloadPriviledge,

      filterState,
      listFilterConditions: ListFilterConditions,
      filterCount,
      selectItemList,
      onChangeMultiSelect,
      onSearchText,
      onSubmitFilter,
      onResetFilter,

      currentPage,
      displayCount,
      displayCountSelectList,
      totalPageCount,
      onChangePage,
      onChangeDisplayCount,

      onChangeOrder,

      selectedRowList,
      selectedRowCount,
      onChangeRowValue,

      isLoading,

      onClickCsvDownload,
      csvCustomizeModalShow,
      closeCsvCustomizeModal,
      showCsvCustomizeModal,
      csvDownloadConfirmModalShow,
      closeCsvDownloadConfirmModal,
      excludedColumns,
      includedColumns,
      applyCsvDownload,
      updateCsvIncludedColumns,
      updateCsvExcludedColumns,

      currentDateStr,
      handleChangedEntryDateFrom,
      handleChangedEntryDateTo
    };
  }
});
